import type { PipelineStage } from "@/lib/api/types";

/**
 * The canonical archive stage for a job: the "Archived" system stage. Matches
 * the backend's StageService.get_system_stage(job_id, "Archived") identity
 * (name === "Archived" && is_system). Do NOT use a last-position heuristic.
 */
export function getArchiveStage(
  stages: PipelineStage[],
): PipelineStage | null {
  return stages.find((s) => s.is_system && s.name === "Archived") ?? null;
}
